import { isMobile } from './device-utils';

export const LOCAL_NAV_EL_SELECTOR = '.j-local-nav';
export const SECTION_NAV_EL_SELECTOR = '.j-section-nav';
export const HERO_SLIM_IS_VISIBLE = 'isVisible';
export const HERO_SLIM_HOOK = '.j-hero-lmp-slim';
export const HERO_HOOK = '.j-intro';

export const CSS_PREFIX = 'ftbl__';
export const TAB_ITEM_CLASS_PREFIX = 'tab-item--';
export const CHIP_ITEM_CLASS_PREFIX = 'chip-item--';
export const ACTIVE_TAB_CLASS_PREFIX = 'active-tab--';
export const TABS_MENU_CLASSNAME = 'tabs-menu';

export const getActiveTab = (): Element | null => {
  const tabsMenuElement: Element | null = document.querySelector(`.${CSS_PREFIX}${TABS_MENU_CLASSNAME}`);

  if (tabsMenuElement) {
    // CURRENT TAB
    const activeTabAttribute: string = tabsMenuElement.getAttribute('data-state') ?? '';

    // From "active-tab--3" to "tab-item--3"
    const activeTab: string = activeTabAttribute.replace(ACTIVE_TAB_CLASS_PREFIX, TAB_ITEM_CLASS_PREFIX);

    // If found
    return activeTab.includes(TAB_ITEM_CLASS_PREFIX) ? document.querySelector(`#${CSS_PREFIX}${activeTab}`) : null;
  }

  return null;
};

/**
 * Scrolls passed tab into viewport
 */
export const activeTabScrollIntoView = () => {
  const activeTabElement: Element | null = getActiveTab();

  if (activeTabElement) {
    tabScrollIntoView(activeTabElement, 'auto');
    window.scrollTo({ top: 0 });
  }
};

export const tabScrollIntoView = (tab: Element, behavior: ScrollBehavior = 'smooth'): void => {
  if (isMobile() && tab && typeof tab.scrollIntoView === 'function') {
    tab.scrollIntoView({
      behavior,
      block: 'nearest',
      inline: 'center',
    });
  }
};

/**
 * Is HERO SLIM/STICKY visible in this moment?
 * @param heroSlimEl Hero Slim HTML Element
 * @returns boolean
 */
export const isSticky = (heroSlimEl: HTMLElement | null): boolean =>
  heroSlimEl ? heroSlimEl.getAttribute('data-state') === HERO_SLIM_IS_VISIBLE : false;

/**
 * Utility function to scroll to top of the tab
 * @param tabDiv tab div element
 */
export const anchorTabOnTop = () => {
  const heroEl: HTMLElement | null = document.querySelector(HERO_HOOK);
  const heroSlimEl: HTMLElement | null = document.querySelector(HERO_SLIM_HOOK);

  if (heroEl && heroSlimEl && isSticky(heroSlimEl)) {
    const localNavElHeight = Number(document.querySelector(LOCAL_NAV_EL_SELECTOR)?.getBoundingClientRect().height);
    const sectionNavElHeight = Number(document.querySelector(SECTION_NAV_EL_SELECTOR)?.getBoundingClientRect().height);
    const heroSlimElHeight = heroSlimEl.getBoundingClientRect().height;

    const offset = localNavElHeight + sectionNavElHeight + heroSlimElHeight - 2;
    window.scrollTo({ top: heroEl.getBoundingClientRect().bottom + window.scrollY - offset });
  }
};

// ISS-5096
export const clickFromHash = () => {
  // Get #HASH of CURRENT URL
  const hash: string = getHash();

  if (hash !== '') {
    // CLICK on TAB with DATA-URL=#HASH
    const tab: HTMLElement | null = document.querySelector(`.ftbl__tab-item[data-url="${hash}`);
    if (tab) {
      tab.click();
    } else {
      console.warn('Tab with DATA-URL', hash, 'not found'); // eslint-disable-line no-console
    }
  }
};

export const getHash = (): string => {
  return window!.location!.hash ?? '';
};
